import axios from 'axios'
import * as util from '@/assets/js/util'

// export const baseUrl = 'http://192.168.1.61:8080'//192.168.3.32:8086 //203.85.72.1:8086
// export const shareUrl = 'http://203.85.72.1:8086'

export const baseUrl = 'https://ms.hojinnavi.com'
// export const baseUrl = 'http://47.242.180.16:8085'
// export const baseUrl = 'http://192.168.3.2:8085'
export const shareUrl = process.env.NODE_ENV === 'development' ? 'https://m.hojinnavi.com/#' : 'https://m.hojinnavi.com/#'
// export const shareUrl = process.env.NODE_ENV === 'development' ? 'http://47.242.180.16:8080/bg/#' : 'http://47.242.180.16:8080/bg/#'
//
// export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://member.xyzy.online' : 'http://192.168.31.241:8080'

// export const baseUrl = 'http://192.168.31.241:8080'

export function get (url, data) {
  // url = 'http://120.78.145.189:9000' + url
  url = baseUrl + url + '?t=' + util.getNow()
  return axios.get(url, data)
}

export async function post (url, data, option) {
  const form = []
  addItemsToForm(form, [], data)
  url = baseUrl + url + '?t=' + util.getNow()
  return axios.post(url, form.join('&'), option)
}

export async function deletes (url, data, option) {
  const form = []
  addItemsToForm(form, [], data)
  url = baseUrl + url + '?t=' + util.getNow()
  return axios.delete(url, form.join('&'), option)
}

export async function uploadPost (url, data, headers) {
  url = baseUrl + url + '?t=' + util.getNow()
  return axios.post(url, data, headers)
}

export function params (data) {
  let url = ''
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}

function addItemsToForm (form, names, obj) {
  if (obj === undefined || obj === '' || obj === null) return addItemToForm(form, names, '')

  if (
    typeof obj === 'string' ||
    typeof obj === 'number' ||
    obj === true ||
    obj === false
  ) {
    return addItemToForm(form, names, obj)
  }

  if (obj instanceof Date) return addItemToForm(form, names, obj.toJSON())

  // array or otherwise array-like
  if (obj instanceof Array) {
    return obj.forEach((v, i) => {
      names.push(`[${i}]`)
      addItemsToForm(form, names, v)
      names.pop()
    })
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).forEach((k) => {
      const newK = k.replace(/_\$search[^\\.]*/ig, '')
      names.push(newK)
      addItemsToForm(form, names, obj[k])
      names.pop()
    })
  }
}

function addItemToForm (form, names, value) {
  const name = encodeURIComponent(names.join('.').replace(/\.\[/g, '['))
  const newValue = encodeURIComponent(value.toString())
  form.push(`${name}=${newValue}`)
}



// WEBPACK FOOTER //
// ./src/assets/js/json.js